module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/object/define-property"
// module id = 10
// module chunks = 0